<template>
  <div class="is-open props-group">
    <el-form-item label="默认开启">
       <el-tooltip content="开关控件开启时存储的数据为:是,开关控件关闭时存储的数据为:否" placement="top" class="tooltip">
          <span class="fa fa-question-circle"></span>
      </el-tooltip>
     <el-checkbox v-model="component.properties.isOpen"></el-checkbox>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-is-open',
  props: ['component']
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/is-open.vue